import script from "./AccessSharingConfirmationView.vue?vue&type=script&setup=true&lang=js"
export * from "./AccessSharingConfirmationView.vue?vue&type=script&setup=true&lang=js"

import "./AccessSharingConfirmationView.vue?vue&type=style&index=0&id=3787fff5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3787fff5"]])

export default __exports__